import { prepareLink, PrepareLinkParams } from '@gem/utils';

import { getNavigate, getLocation } from './refs';

export function replaceTo(data: Partial<PrepareLinkParams> = {}): void {
  const navigate = getNavigate();
  const location = getLocation();

  if (navigate && location) {
    const link = prepareLink({ ...data, location });
    navigate(`${link.pathname}${link.search}`, { replace: true, state: link.state });
  }
}
